// extracted by mini-css-extract-plugin
module.exports = {"container":"email-login_container__3M7qp","forgot":"email-login_forgot__JwUH1","loading":"email-login_loading__2utZL","error":"email-login_error__2jCEo"};